import React from 'react'
import './styles.less'
import GoBackButton from '../buttons/goBackButton/GoBackButton'
import { Col, Row } from 'rsuite'

export default function ContentHeaderWidget({
  header,
  subHeader,
  isShowGoButton = false,
  cleanSessions,
  hideSubHeader,
}) {
  return (
    <>
      <div className="content-header" style={{ marginTop: 12 }}>
        <Row>
          <Col
            lg={isShowGoButton ? 18 : 24}
            md={isShowGoButton ? 18 : 24}
            sm={isShowGoButton ? 18 : 24}
            xs={24}
          >
            <h1>{header}</h1>
            {!hideSubHeader && <p>{subHeader || ''}</p>}
          </Col>

          {isShowGoButton && (
            <Col lg={6} md={6} sm={6} xs={24} style={{ textAlign: 'right' }}>
              <div style={{ marginTop: 30 }}>
                <GoBackButton cleanSessions={cleanSessions} />
              </div>
            </Col>
          )}
        </Row>

        <hr />
      </div>
    </>
  )
}
